export default __webpack_public_path__ + "static/media/edge.3f8a9334.png";